import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {GetGenderedCardsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/browse_page/v1/service.types';
import {CardsSlider} from '@aboutyou/ui-components';
import React from 'react';
import {useSelectedTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';
import {CardSlide} from './CardSlide';

export interface CardsSliderViewProps {
  className?: string;
}

export const CardsSliderView: React.FC<
  CardsSliderViewProps & GetGenderedCardsResponse
> = ({type, className}) => {
  const {targetGroup} = useSelectedTargetGroup();
  const {isActive: isBasHugoTakeoverActive} = useIsFeatureActive(
    'bas_homepage_campaign_hugo',
  );

  if (!type || type.$case === 'empty') {
    return null;
  }

  return (
    <CardsSlider
      key={targetGroup}
      className={className}
      cards={type.cardSliders.cards}
      CardComponent={CardSlide}
      extendFirstCardTimeout={isBasHugoTakeoverActive}
    />
  );
};
